import { useCallback } from "react";
import { getValidationCodes } from "../../../api/ValidationCodes";
import { logCustomMessage } from "../../../util/logger";
import { SeverityLevel } from "@microsoft/applicationinsights-web";
import { useWorkOrderStore } from "../../../store/wo-order";

export default function useGetRateList() {
  const setRateList = useWorkOrderStore((state) => state.setRateList);

  const getRateList = useCallback(async () => {
    const response = await getValidationCodes("Entity__RateMultiplier");
    const data = {
      twType: "Entity__RateMultiplier",
    };
    logCustomMessage(
      "Get validation codes for Rate Multiplier",
      SeverityLevel.Information,
      "ValidationCodes/Get",
      data,
      response
    );
    if (response.status === 200 && !response.isError) {
      setRateList(response.data);
    }
    return response;
  }, [setRateList]);

  return { getRateList };
}
